/* eslint-env browser, es6 */
import m from "mithril";

import { WordListView } from "./word-list";
import { scoreWordBase } from "../scoring";

interface MissedWordsViewAttrs {
  missedWords: string[];
}

export class MissedWordsView implements m.Component<MissedWordsViewAttrs> {
  private missedWords: string[];

  constructor(vnode: m.Vnode<MissedWordsViewAttrs>) {
    this.missedWords = vnode.attrs.missedWords;
  }

  view(): m.Children {
    if (this.missedWords.length > 0) {
      const wordList: [string, number][] = this.missedWords.map((word) => [
        word,
        scoreWordBase(word),
      ]);

      return [
        m("div.missed-msg", "You missed:"),
        m(WordListView, { wordList }),
      ];
    } else {
      return m("div.missed-msg", "You named everything!");
    }
  }
}
